/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 22.10.17.
 */
import update from 'immutability-helper';
import SimpleHelper from "./SimpleHelper";
import t from "../../trans";
import {InvalidActionException} from "../../Exceptions";

/**
 * Performs change in person object "personRoleCollection".
 * In addition to usual object item change performs also control of "isDefault" field. If this field is set on
 * changeable item then all other items will get false value for this field.
 */
class PersonPasswordHelper extends SimpleHelper {
    /**
     * Apply change to the object data.
     * Requires that new data should contain fields "password", "newPassword", "newPassword2".
     * Verifies that "newPassword" and "newPassword2" are matching. Updates to the data only fields "password" and
     * "newPassword".
     * @param {string} action Action to perform to the data. Only "update" is supported.
     * @param {Object} oldValue Old value
     * @param {Object} newValue New value
     * @param {Schema} schema Schema object for this data
     * @returns {Object} Returns changed data. If there were errors then resulted value is null and method
     * isError() returns true. NB! It is possible, that returned value is null and there are no errors! This is normal -
     * this means that assigned value should be null.
     */
    applyObjectAction(action, oldValue, newValue, schema) {
        if (action !== "update") throw new InvalidActionException("Only 'update' action is possible for objects");
        let errors = [];
        if (!newValue.password) errors.push(t("password: Value is required"));
        if (!newValue.newPassword) errors.push(t("newPassword: Value is required"));
        if (!newValue.newPassword2) errors.push(t("newPassword2: Value is required"));
        if (newValue.newPassword != newValue.newPassword2) errors.push(t("Password values do not match"));
        if (errors.length > 0) {
            this.errors = errors;
            return null;
        }
        return update(newValue, {$unset: ["newPassword2"]});
    }
}

export default PersonPasswordHelper;
